import { CaretDownOutlined } from "@ant-design/icons";
import { Modal, Typography } from "antd";
import Img from "assets/images";
import { useGetSellerUserSegments } from "hooks/seller";
import { useState } from "react";

const MAIN_OPTIONS = [
  {
    value: "ALL",
    label: "Tất cả đại lý",
    desc: "Bao gồm danh sách tất cả đại lý hiện tại và đại lý được thêm mới trong tương lai",
    icon: Img.ImageGroupSeller,
  },
  {
    value: "group",
    label: "Nhóm đại lý cụ thể",
    desc: "Bao gồm các nhóm đại lý được xác định theo các tiêu chí cụ thể",
    icon: Img.ImageSpecificSeller,
    hasSubItems: true,
  },
  {
    value: "HAVE_VOUCHER_CODE",
    label: "Đại lý có vouchers",
    desc: "Bao gồm các trường hợp khi chưa có thông tin cụ thể về nhóm đại lý",
    icon: Img.ImageSellerVoucher,
  },
];

const SUB_OPTIONS = [
  {
    value: "NEW_SELLER",
    label: "Đại lý mới",
    desc: "Là những đại lý chưa có trong hệ thống Đại lý Hồng Anh",
  },
  {
    value: "NOT_LOGGED_IN",
    label: "Đại lý chưa sử dụng app",
    desc: "Là những đại lý chưa có tài khoản để đăng nhập app đại lý Hồng Anh",
  },
  {
    value: "NO_ORDER",
    label: "Đại lý chưa phát sinh đơn hàng",
    desc: "Là những đại lý chưa phát sinh đơn hàng trên app Đại lý Hồng Anh",
  },
  {
    value: "IN_GROUP",
    label: "Từ danh sách đại lý hiện có",
    desc: "Là những đại lý đã có thông tin trong hệ thống Đại lý Hồng Anh",
  },
];

export const TargetCustomerModal = ({ visible, onCancel, onSelect, currentType }) => {
  const [isGroupExpanded, setIsGroupExpanded] = useState(false);
  const { data } = useGetSellerUserSegments();

  // Hàm lấy sellerSegmentID từ API data dựa vào type
  const getSellerSegmentID = (type) => {
    const segment = data?.find((item) => item.type === type);
    return segment?.id || "omexnJARXqKN_1"; // Mặc định nếu không tìm thấy
  };

  const handleSelect = (value) => {
    const sellerSegmentID = getSellerSegmentID(value);
    onSelect?.(value, sellerSegmentID);
    onCancel?.();
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={520}
      title={<span style={{ fontWeight: 700, fontSize: 15 }}>Chọn nhóm đại lý</span>}
      bodyStyle={{ padding: "13px" }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        {MAIN_OPTIONS.map((option) => {
          const isSelected = currentType === option.value;
          const isGroupOption = option.value === "group";

          return (
            <div key={option.value}>
              <div
                onClick={() => {
                  if (isGroupOption) {
                    setIsGroupExpanded(!isGroupExpanded);
                  } else {
                    handleSelect(option.value);
                  }
                }}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  background: isGroupOption && isGroupExpanded ? "#EEF4FF" : isSelected ? "#EEF4FF" : "#fff",
                  borderRadius: 12,
                  padding: "10px 16px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                  border: isSelected ? "1px solid #2246DC" : "1px solid transparent",
                }}
              >
                <span style={{ fontSize: 24, marginRight: 16, flexShrink: 0 }}>
                  <img src={option.icon} alt="" width={24} />
                </span>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography.Text
                      style={{
                        fontWeight: 700,
                        fontSize: 13,
                        color: isSelected || (isGroupOption && isGroupExpanded) ? "#2246DC" : "#101828",
                      }}
                    >
                      {option.label}
                    </Typography.Text>
                    {isGroupOption && (
                      <span
                        style={{
                          fontSize: 12,
                          transform: isGroupExpanded ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.2s",
                        }}
                      >
                        <CaretDownOutlined />
                      </span>
                    )}
                  </div>
                  <div style={{ color: "#667084", fontSize: 12, marginTop: 4 }}>{option.desc}</div>
                </div>
              </div>

              {isGroupOption && isGroupExpanded && (
                <div style={{ marginTop: 4, marginLeft: 48, display: "flex", flexDirection: "column" }}>
                  {SUB_OPTIONS.map((subOption) => {
                    const isSubSelected = currentType === subOption.value;
                    return (
                      <div
                        key={subOption.value}
                        onClick={() => handleSelect(subOption.value)}
                        style={{
                          background: isSubSelected ? "#EEF4FF" : "#fff",
                          borderRadius: 12,
                          padding: "10px 16px",
                          cursor: "pointer",
                          transition: "background 0.2s",
                        }}
                      >
                        <Typography.Text
                          style={{
                            fontWeight: 600,
                            fontSize: 13,
                            color: isSubSelected ? "#2246DC" : "#101828",
                          }}
                        >
                          {subOption.label}
                        </Typography.Text>
                        <div style={{ color: "#667084", fontSize: 12, marginTop: 2 }}>{subOption.desc}</div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default TargetCustomerModal;
